import React, { useState } from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import { DashboardShell } from '@/design-system/components/DashboardShell'
import { AdminNav } from './AdminNav'
import { AdminDashboard } from './AdminDashboard'
import { PhotographerManagement } from './PhotographerManagement'
import { MissionManagement } from './MissionManagement'
import { ImageReview } from './ImageReview'
import { PayoutManagement } from './PayoutManagement'
import { ClientManagement } from './ClientManagement'
import { SubmissionManagement } from './SubmissionManagement'

export function AdminLayout() {
  const [mobileNavOpen, setMobileNavOpen] = useState(false)

  const sidebar = <AdminNav />

  const header = (
    <div className="flex items-center justify-between w-full">
      <button
        className="lg:hidden p-2 rounded-lg text-text-secondary hover:text-text-primary hover:bg-surface-overlay"
        onClick={() => setMobileNavOpen(true)}
      >
        ☰
      </button>
      <div className="flex items-center gap-2 ml-auto">
        <span className="text-xs text-text-muted">Wavult Admin</span>
        <div className="w-6 h-6 rounded-full bg-brand-accent/20 flex items-center justify-center">
          <span className="text-xs font-bold text-brand-accent">W</span>
        </div>
      </div>
    </div>
  )

  return (
    <>
      {/* Mobile nav overlay */}
      {mobileNavOpen && (
        <div
          className="fixed inset-0 bg-black/60 z-40 lg:hidden"
          onClick={() => setMobileNavOpen(false)}
        >
          <div
            className="w-64 h-full bg-surface-raised border-r border-surface-border"
            onClick={e => e.stopPropagation()}
          >
            <AdminNav />
          </div>
        </div>
      )}

      {/* Desktop: show sidebar in shell. Mobile: hide sidebar from shell */}
      <div className="hidden lg:block h-screen">
        <DashboardShell sidebar={sidebar} header={header}>
          <AdminRoutes />
        </DashboardShell>
      </div>

      {/* Mobile layout */}
      <div className="lg:hidden min-h-screen bg-surface-base">
        <header className="h-14 border-b border-surface-border flex items-center px-4 bg-surface-raised">
          {header}
        </header>
        <main className="p-4">
          <AdminRoutes />
        </main>
      </div>
    </>
  )
}

function AdminRoutes() {
  return (
    <Routes>
      <Route index element={<AdminDashboard />} />
      <Route path="photographers" element={<PhotographerManagement />} />
      <Route path="missions" element={<MissionManagement />} />
      <Route path="images" element={<ImageReview />} />
      <Route path="payouts" element={<PayoutManagement />} />
      <Route path="clients" element={<ClientManagement />} />
      <Route path="submissions" element={<SubmissionManagement />} />
      <Route path="*" element={<Navigate to="/admin" replace />} />
    </Routes>
  )
}
